import ModalDeleteFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteTaskRepositoryTagProps extends ModalEditComponentProps { }

const ModalDeleteTaskRepositoryTag: React.FC<ModalDeleteTaskRepositoryTagProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/task/repository/tag/deleteTaskRepositoryTag',
        data: {
            id: allRowData?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteTagRepository', '¿Seguro que quieres eliminar esta etiqueta de repositorio?'),
            subtitle: t('onceDeletedNotRecover', 'Una vez eliminada no podrás recuperarla')
        }} />
    )
}

export default ModalDeleteTaskRepositoryTag